import api from "lib/api";


const AdminApi =  {
    loadRoute: async () =>{
        return await api.get("/adminarea/routing");
    }
}
export default AdminApi;
